export default "__VITE_PUBLIC_ASSET__0ea4018a__"